import * as React from 'react';
import { Search as SearchIcon } from '@mui/icons-material';
import { InputBase, Box, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Search() {
  const theme = useTheme();
  const [word, setWord] = React.useState('');
  const navigate = useNavigate();

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (event.keyCode === 13 && word) {
      navigate(`/search/${word}`);
    }
  };

  return (
    <Box
      sx={{
        borderRadius: theme.shape.borderRadius,
        // backgroundColor: fade(theme.palette.common.white, 0.15),
        // '&:hover': {
        //   backgroundColor: fade(theme.palette.common.white, 0.25),
        // },
        display: 'inline-flex',
        alignItems: 'center',
        margin: theme.spacing(0, 1),
      }}
    >
      <SearchIcon
        sx={{
          pointerEvents: 'none',
          margin: theme.spacing(0, 1),
        }}
      />
      <InputBase
        value={word}
        onChange={(e) => setWord(e.target.value)}
        sx={{
          input: {
            color: 'inherit',
            paddingRight: theme.spacing(1),
            transition: theme.transitions.create('width'),
            width: 120,
            '&:focus': {
              width: 200,
            },
          },
        }}
        placeholder="搜索"
        inputProps={{ 'aria-label': 'Search' }}
        onKeyDown={handleKeyDown}
      />
    </Box>
  );
}
